import { createActions, createReducer } from "reduxsauce";
import { onChangeFieldValue } from "utils/functions";
import { defaultState } from "./readers-model";

export const showLoading = (state) => ({
  ...state,
  isLoading: true,
});

export const hideLoading = (state) => ({
  ...state,
  isLoading: false,
});

export const showLoadingForm = (state) => ({
  ...state,
  isLoadingForm: true,
});

export const hideLoadingForm = (state) => ({
  ...state,
  isLoadingForm: false,
});

export const showDrawer = (state) => ({
  ...state,
  visibleDrawer: true,
});

export const hideDrawer = (state) => ({
  ...state,
  visibleDrawer: false,
  form: { ...defaultState.form },
});

export const showDeleteModal = (state) => ({
  ...state,
  visibleDeleteModal: true,
});

export const hideDeleteModal = (state) => ({
  ...state,
  visibleDeleteModal: false,
});

export const showLoadingTable = (state = defaultState) => ({
  ...state,
  isLoadingTable: true,
});

export const hideLoadingTable = (state = defaultState) => ({
  ...state,
  isLoadingTable: false,
});

export const showLoadingDrawer = (state = defaultState) => ({
  ...state,
  isLoadingDrawer: true,
});

export const hideLoadingDrawer = (state = defaultState) => ({
  ...state,
  isLoadingDrawer: false,
});

export const changeFieldValue = (state, { fieldName, value }) => ({
  ...state,
  filter: onChangeFieldValue(state.filter, fieldName, value),
});

export const updateFilter = (state, action: any) => {
  return {
    ...state,
    searchFilter: action.filter,
  };
};

export const fetchReaders = (state, { items, totalItems }) => ({
  ...state,
  isLoadingTable: false,
  items,
  totalItems,
});

export const updateFormReader = (state, { formReader }) => ({
  ...state,
  form: {
    ...state.form,
    reader: {
      ...state.form.reader,
      ...formReader,
    },
  },
});

export const updateFormAntenna = (state, { formAntenna }) => ({
  ...state,
  form: {
    ...state.form,
    ...state.formAntenna,
    ...formAntenna,
  },
});

export const updateFormReaderAntenna = (state, { formReaderAntenna }) => ({
  ...state,
  form: formReaderAntenna,
});

export const removeAntenna = (state, { antennaId }) => ({
  ...state,
  form: {
    ...state.form,
    antennas: state.form.antennas.map((antenna, i) =>
      i === antennaId
        ? {
            modelDescription: antenna?.modelDescription,
          }
        : antenna
    ),
  },
});

export const { Types, Creators } = createActions({
  readersShowLoading: [],
  readersHideLoading: [],
  readersShowDrawer: [],
  readersHideDrawer: [],
  readersShowDeleteModal: [],
  readersHideDeleteModal: [],
  readersShowLoadingTable: [],
  readersShowLoadingDrawer: [],
  readersHideLoadingDrawer: [],
  readersHideLoadingTable: [],
  readersUpdateFilter: ["filter"],
  readersUpdateFormReader: ["formReader"],
  readersUpdateFormAntenna: ["formAntenna"],
  readersUpdateFormReaderAntenna: ["formReaderAntenna"],
  readersChangeFieldValue: ["fieldName", "value"],
  readersFetchRegister: ["items", "totalItems"],
  readersRemoveAntenna: ["antennaId"],
  readersShowLoadingForm: [],
  readersHideLoadingForm: [],
  readersRegisterFetchAsync: [],
  readersAntennaUpdatedAsync: [],
  readersAntennaFetchByIdAsync: ["id"],
  readersAntennaReaderDeleteByIdAsync: ["readerId"],
});

export default createReducer(defaultState, {
  [Types.READERS_SHOW_LOADING]: showLoading,
  [Types.READERS_HIDE_LOADING]: hideLoading,
  [Types.READERS_SHOW_LOADING_FORM]: showLoadingForm,
  [Types.READERS_HIDE_LOADING_FORM]: hideLoadingForm,
  [Types.READERS_SHOW_DRAWER]: showDrawer,
  [Types.READERS_HIDE_DRAWER]: hideDrawer,
  [Types.READERS_SHOW_DELETE_MODAL]: showDeleteModal,
  [Types.READERS_HIDE_DELETE_MODAL]: hideDeleteModal,
  [Types.READERS_SHOW_LOADING_TABLE]: showLoadingTable,
  [Types.READERS_HIDE_LOADING_TABLE]: hideLoadingTable,
  [Types.READERS_SHOW_LOADING_DRAWER]: showLoadingDrawer,
  [Types.READERS_HIDE_LOADING_DRAWER]: hideLoadingDrawer,
  [Types.READERS_CHANGE_FIELD_VALUE]: changeFieldValue,
  [Types.READERS_UPDATE_FILTER]: updateFilter,
  [Types.READERS_FETCH_REGISTER]: fetchReaders,
  [Types.READERS_UPDATE_FORM_READER]: updateFormReader,
  [Types.READERS_UPDATE_FORM_ANTENNA]: updateFormAntenna,
  [Types.READERS_REMOVE_ANTENNA]: removeAntenna,
  [Types.READERS_UPDATE_FORM_READER_ANTENNA]: updateFormReaderAntenna,
});
